import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'sgt-dna-desvincular',
  templateUrl: './dna-desvincular.component.html',
  styleUrls: ['./dna-desvincular.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DnaDesvincularComponent {
  @Input() nomeDna = '';
  @Input() parametrosMutados = '';

  @Output() confirmar = new EventEmitter<void>();
  @Output() fechar = new EventEmitter<void>();

  get temMutacao(): boolean {
    return !!this.parametrosMutados;
  }
}
